import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { cbURL } from "../../common/baseConfig";

export class PayWithCode extends Component {
  static propTypes = {
    pay: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    payType: -1,//0支付宝 1微信 2建行 3聚合扫码
  }
  componentDidMount() {
    let path = this.props.history.location.pathname;
    let pathArr = path.split("/");
    let orderId = pathArr[3];
    let payType = parseInt(pathArr[2], 10);
    //轮循订单状态
    this.timer = setInterval(() => {
      this.props.actions.fetchQueryOrder({ Id: orderId }).then(res => {
        if (res.SuccessResponse) {
          if (res.Data.PayStatus === 1) {
            //支付成功
            clearInterval(this.timer);
            this.props.history.push(`/paysuccess/${payType}/${orderId}`);
          }
        }
      })
    }, 1000);
    this.setState({
      payType,
    }, () => {
      //获取订单详情
      this.props.actions.fetchGetOrderPayById({
        orderId,
      }).then(res => {
        if (res.SuccessResponse) {
          //获取token
          this.props.actions.fetchGetAccessToken().then(
            res1 => {
              if (res1.SuccessResponse) {
                let token = res1.Data.access_token;
                let params = {}
                params.OutTradeNo = orderId;
                if (payType === 1) {
                  //微信
                  params.Body = "购课支付";
                  params.CallerReturnUrl = window.location.origin + "/paysuccess/" + payType + "/" + orderId;
                }
                params.TotalAmount = payType === 1 ? res.Data.Price * 100 : res.Data.Price;
                params.CallerNotifyUrl = `${cbURL}service/datastore/PayGateway/${payType === 1 ? "WXFinancePayNotifyWX" : "WXFinancePayNotifyCCB"}`;
                params.Token = token;
                if (payType === 1) {
                  //微信
                  this.props.actions.fetchWeChatScanPay(params);
                } else {
                  //聚合
                  params.Remark1 = "";
                  params.Remark2 = "";
                  params.IssInCode = "";
                  params.InstallNum = "";
                  this.props.actions.fetchAggregatePay(params);
                }
              }
            }
          )
        }
      });
    })
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    const { fetchGetOrderPayByIdSuccess, fetchWeChatScanPaySuccess, fetchAggregatePaySuccess } = this.props.pay;
    const { payType } = this.state;
    return (
      <div className="pay-pay-with-code">
        <div className="banner">
          <h1>支付中心</h1>
        </div>
        {
          fetchGetOrderPayByIdSuccess && <div className="code-detail">
            <h2>
              <p>订单号:&nbsp;&nbsp;{fetchGetOrderPayByIdSuccess.OrderNo}</p>
              <p>下单时间:&nbsp;&nbsp;{fetchGetOrderPayByIdSuccess.OrderTime}</p>
            </h2>
            {
              fetchGetOrderPayByIdSuccess && <div className="double-code">
                <strong>{payType === 1 ? "微信" : "聚合扫码"}支付:<span>¥{fetchGetOrderPayByIdSuccess.UsedPrice > 0 ? (fetchGetOrderPayByIdSuccess.Price - fetchGetOrderPayByIdSuccess.UsedPrice).toFixed(2) : fetchGetOrderPayByIdSuccess.Price.toFixed(2)}</span></strong>
                <div className="QRcode">
                  <img src={payType === 1 ? fetchWeChatScanPaySuccess : fetchAggregatePaySuccess} alt="" />
                </div>
                <p>请使用{payType === 1 ? "微信" : "微信、支付宝或者建行扫码"}扫描二维码付款</p>
              </div>
            }

          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pay: state.pay,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayWithCode);



// WEBPACK FOOTER //
// ./src/features/pay/PayWithCode.js